import React from 'react'
import { makeStyles } from '@material-ui/styles'
import PaperWithPadding from 'components/templates/PaperWithPadding'
import BrandWidget from '../organisms/BrandWidget'
import useInitialProps from '../../hooks/useStaticContext'

const useStyles = makeStyles({
  root: {
    width: 'fit-content',
  },
})

const BrandPage = ({ staticContext }) => {
  const { brandUrl, cardsCount, logo, name } = useInitialProps(staticContext)
  const classes = useStyles()

  return (
    <PaperWithPadding padding={0.5} className={classes.root}>
      <BrandWidget
        brandUrl={brandUrl}
        cardsCount={cardsCount}
        logo={logo}
        name={name}
      />
    </PaperWithPadding>
  )
}
export default BrandPage
